import {
  Col,
  DirectionArrow,
  Row,
  Seat,
  SeatsContainer,
  SeatSpace,
  TrainCarContainer,
  UnknownType,
} from './components';

export const registry = {
  get(name: string) {
    const components = {
      TrainCarContainer,
      Seat,
      SeatsContainer,
      SeatSpace,
      Row,
      Col,
      DirectionArrow,
    };
    // @ts-expect-error ...
    return components[name] || null;
  },
  UnknownType: UnknownType,
};
